import "../chunk-PKUHTIDK.js";
import { breadcrumbItemSelect } from "./index";
const api = ["breadcrumbItemSelect"];
const renderless = (props, { reactive, provide }, { emit, constants, emitter }) => {
  const state = reactive({
    breadcrumbEmitter: emitter(),
    currentBreadcrumbItem: {}
  });
  const api2 = {
    breadcrumbItemSelect: () => breadcrumbItemSelect({ api: api2, emit, state, constants })
  };
  provide("breadcrumbEmitter", state.breadcrumbEmitter);
  api2.breadcrumbItemSelect();
  return api2;
};
export {
  api,
  renderless
};
